import { Form } from "@/pages/configuration/pages/forms/models/Form";
import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";

export const getForms = async (signal?: AbortSignal) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];
	const resp = await apiService.callV2(
		"[FORMS].[GetFormsForUser]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as Form[];
	} else {
		throw new Error(resp.message || "Error fetching forms");
	}
};
